import type {FinishedResponseInteractionService} from 'shared/services';
import type {SearchParams, UUID} from 'src/typings';
import type {
    RecordBulkEditDataService,
    RecordBulkEditParams
} from 'src/features/record/record-bulk-edit.data-service';

export class RecordBulkEditService {
    public static serviceName = 'recordBulkEditService';

    /*@ngInject*/
    constructor(private recordBulkEditDataService: RecordBulkEditDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async bulkEditRecords<PARAMS extends SearchParams = SearchParams>(params: PARAMS, bulkEditParams: RecordBulkEditParams): Promise<UUID[]> {
        try {
            return await this.recordBulkEditDataService.bulkEditRecords(params, bulkEditParams);
        } catch (e) {
            this.finishedResponseInteractionService.showFailedResponseInToast(e);
            return [];
        }
    }
}